import { render } from "./CustomResponsesByCustomer.vue?vue&type=template&id=5569a633&scoped=true"
import script from "./CustomResponsesByCustomer.vue?vue&type=script&lang=js"
export * from "./CustomResponsesByCustomer.vue?vue&type=script&lang=js"

import "./CustomResponsesByCustomer.vue?vue&type=style&index=0&id=5569a633&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5569a633"]])

export default __exports__